import {Component, computed, input, signal, inject} from '@angular/core';
import {
  PhaseStatusView,
  TenderStatus,
  ProviderTenderControllerService,
  TenderPhaseType,
} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../../shared/components/loading/loading.component';
import {Card} from 'primeng/card';
import {GenericQuestionnaireComponent} from '../../../../../../shared/components/provider-questionnaire/generic-questionnaire/generic-questionnaire.component';
import {TenderResponseRfqComponent} from '../../../../tender-wizard/rfq/tender-response-rfq/tender-response-rfq.component';
import {TenderDemonstrationAgendaComponent} from '../../../../tender-wizard/rfd/tender-demonstration-agenda/tender-demonstration-agenda.component';
import {IconButtonDialogComponent} from '../../../../../../shared/components/dialog/icon-button-dialog/icon-button-dialog.component';
import {TenderRfcProjectConclusionComponent} from '../../../../tender-wizard/rfc/tender-rfc-project-conclusion/tender-rfc-project-conclusion.component';

@Component({
  selector: 'app-tender-provider-response-button',
  imports: [
    LoadingComponent,
    Card,
    GenericQuestionnaireComponent,
    TenderResponseRfqComponent,
    TenderDemonstrationAgendaComponent,
    IconButtonDialogComponent,
    TenderRfcProjectConclusionComponent,
  ],
  templateUrl: './tender-provider-response-button.component.html',
})
export class TenderProviderResponseButtonComponent {
  readonly colorClass = input.required<string>();
  readonly phaseStatusInfo = input.required<PhaseStatusView>();
  readonly tenderId = input.required<number>();
  private readonly providerTenderService = inject(ProviderTenderControllerService);

  protected readonly dialogOpened = signal(false);

  protected readonly hasProviderResponse = computed(
    () => this.phaseStatusInfo().status === TenderStatus.FINISHED,
  );

  protected readonly tenderDetailsResource = rxResource({
    params: () => {
      if (!this.dialogOpened()) return undefined;
      return {
        tenderId: this.tenderId(),
        tenderPhase: this.phaseStatusInfo().phase,
      };
    },
    stream: ({params: request}) => this.providerTenderService.getTenderDetails(request!),
  });

  protected readonly TenderPhaseType = TenderPhaseType;
}
